var map = {
	"./fb.png": "5250",
	"./gmail.png": "740a",
	"./instagram.png": "ae41",
	"./linkedin.png": "b9af",
	"./twitter.png": "0acd",
	"./whatsapp.png": "b126"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f036";